"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showApplyConfig = exports.ShowURI = void 0;
var tslib_1 = require("tslib");
var config_1 = require("@morphic-ts/common/lib/config");
var hkt_1 = require("./hkt");
Object.defineProperty(exports, "ShowURI", { enumerable: true, get: function () { return hkt_1.ShowURI; } });
tslib_1.__exportStar(require("./model"), exports);
/**
 *  @since 0.0.1
 */
exports.showApplyConfig = config_1.getApplyConfig(hkt_1.ShowURI);
